import './ProgressBar.scss'

import React, { Component } from 'react'
import accounting from 'accounting'
import ReactTooltip from 'react-tooltip'

export default class ProgressBar extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    let { averagePercent, valuePercent, top10Percent, averagePercentLabel, top10PercentLabel, valuePercentLabel } = this.props

    averagePercentLabel = averagePercentLabel || averagePercent
    top10PercentLabel = top10PercentLabel || top10Percent

    return (
      <div className="ProgressBar">
        <ReactTooltip effect="solid"/>
        <div className="ProgressBar__backdrop">
          <div className="ProgressBar__progress" style={{width: `${valuePercent !== undefined ? valuePercent : 0}%`}}>
            {
              valuePercent !== undefined || valuePercentLabel ?
                <div className="ProgressBar__value">{valuePercentLabel ? valuePercentLabel : valuePercent}%</div>
                : null
            }

          </div>
          {
            averagePercent !== undefined ?
              <div className="ProgressBar__horizontal-bar" style={{width: `${averagePercent}%`}}><div className="ProgressBar__label" data-tip={accounting.toFixed(averagePercentLabel,1)+'%'}>Avg</div></div>
              : null
          }

          {
            top10Percent !== undefined ?
              <div className="ProgressBar__horizontal-bar" style={{width: `${top10Percent}%`}}><div className="ProgressBar__label" style={{right: `-18px`}} data-tip={accounting.toFixed(top10PercentLabel,1)+'%'}>TOP 10%</div></div>
              : null
          }
        </div>
      </div>
    )
  }

}
